export default __webpack_public_path__ + "static/Plots0008-f619370c620c7e9887f2a367c32f1b72.jpg";